/**
 * Triggered when a flyer is loaded and configurations data is available
 * data: currentFlyer
 */
export const FLYER_EVENT_LOADED = 'flyer-event-loaded';

/**
 * Triggered when a different flyer is requested, usually selected from the side bar
 * data: {newFlyer, oldFlyer}
 */
export const FLYER_EVENT_CHANGED = 'flyer-event-changed';

/**
 * Before pages setup is run. Great time to inject custom pages
 * @type {string}
 */
export const FLYER_EVENT_BEFORE_SETUP = 'flyer-event-before-setup';
